export * from './thermometer.module';
export * from './thermometer.component';
export * from './parameters/parameters.component';
export * from './display/display.component';
export * from './dailydata/dailydata.component';
